import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DateTimePicker, DatePicker } from '@mui/x-date-pickers'
import { TextField } from '@mui/material'

const CommonDateTimePicker = ({
  control,
  name,
  onDateChange,
  type = 'DateTimePicker',
  format = 'YYYY-MM-DD hh:mm A',
  disablePast = true,
  shouldDisableDate,
  propertyTimezone
}) => {
  const [open, setOpen] = useState(false)

  const slotActionBar = ['clear', 'cancel', 'accept']
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={[type]}>
        <Controller
          name={name}
          control={control}
          render={({ field: { value, onChange }, fieldState }) => (
            <>
              {type == 'DateTimePicker' ? (
                <DateTimePicker
                  value={value ? value : null}
                  format={format}
                  timezone={propertyTimezone}
                  open={open}
                  onOpen={() => setOpen(true)}
                  onClose={() => setOpen(false)}
                  shouldDisableDate={shouldDisableDate || false}
                  onChange={(newValue) => {
                    onChange(newValue)
                    onDateChange && onDateChange(newValue)
                  }}
                  disablePast={disablePast}
                  slotProps={{
                    actionBar: {
                      actions: slotActionBar
                    }
                  }}
                  timeSteps={{ hours: 1, minutes: 1 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      InputProps={{
                        ...params.InputProps
                      }}
                    />
                  )}
                />
              ) : (
                type == 'DatePicker' && (
                  <DatePicker
                    value={value ? value : null}
                    format={format}
                    timezone={propertyTimezone}
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    onChange={(newValue) => {
                      onChange(newValue)
                      onDateChange && onDateChange(newValue)
                    }}
                    autoFocus={false}
                    disablePast={disablePast}
                    shouldDisableDate={shouldDisableDate || false}
                    slotProps={{
                      actionBar: {
                        actions: slotActionBar
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        InputProps={{
                          ...params.InputProps
                        }}
                      />
                    )}
                  />
                )
              )}
              {fieldState?.error && <small style={{ color: 'red', marginTop: 0 }}>{fieldState?.error?.message}</small>}
            </>
          )}
        />
      </DemoContainer>
    </LocalizationProvider>
  )
}

export default CommonDateTimePicker
